/**
 * TEMPORARY: Utility to access general feature toggles from the Redux store's initial state.
 *
 * This is needed for code that runs at module load time before React components mount
 * and Redux selectors/hooks are available (e.g., Sentry setup, service worker registration in root.js).
 *
 * WARNING: Do NOT use this pattern elsewhere. Prefer Redux selectors or hooks for accessing store state.
 *
 * TODO (HERMES): During HERMES migration, move these setups (Sentry, service worker, error boundary)
 * to the server side and read toggles there. This file should be removed after that migration.
 */
export const getGeneralToggles = storeState => storeState.featureToggles?.generalToggles ?? {};
